import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import TotalEarningChart from "./TotalEarningChart";
import { FaCcPaypal, FaRegTimesCircle } from "react-icons/fa";
import gpay from "../../assets/payicons/google-pay.svg";
import applepay from "../../assets/payicons/apple-pay.svg";
import paypal from "../../assets/payicons/paypal.svg";
import mastercard from "../../assets/payicons/mastercard.svg";
import visapay from "../../assets/payicons/visa.svg";
import { useGetState } from "../../context/useGetState";
import { errorNotifier, LoadingMessage, successNotifier } from "../..";

const WithdrawChart = ({ earningsData }) => {
  const { dispatch } = useGetState();
  const [active, setActive] = useState(paypal);
  const [showVerification, setShowVerification] = useState(false);

  const boxStyle = {
    p: "10px 50px",
    borderRadius: "5px",
    w: "20%",
    h: "83px",
    border: "1px solid #0276FC",
    cursor: "pointer",
  };

  const inputStyle = {
    bg: "#fff",
    color: "#000",
    _placeholder: { color: "#000" },
  };

  const btnStyle = useColorModeValue(
    { bg: "#0276FC", boxShadow: "0px 2px 7px #0276FC" },
    { bg: "#0076FF", boxShadow: "0px 2px 7px #0076FF" }
  );

  const submitAmount = async (amount) => {
    // Handle form submission here
    setShowVerification(true);
  };

  const submitCode = async (code) => {
    // Handle form submission here
    setShowVerification(false);
    successNotifier(
      "Withdrawal Sent. Might take up to 1-2 days to finish process"
    );
  };

  return (
    <>
      <TotalEarningChart title="Available Balance" data={earningsData} />

      {!showVerification ? (
        <Stack>
          <Stack style={{ marginBottom: "20px" }}>
            <Heading fontSize="1.5em">Select Payment Method</Heading>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems="center"
            >
              <Box {...boxStyle} onClick={() => setActive(gpay)}>
                <Image objectFit={"cover"} w={"60%"} src={gpay} />
              </Box>

              <Box {...boxStyle} onClick={() => setActive(applepay)}>
                <Image objectFit={"cover"} src={applepay} />
              </Box>

              <Box {...boxStyle} onClick={() => setActive(visapay)}>
                <Image objectFit={"cover"} src={visapay} />
              </Box>

              <Box {...boxStyle} onClick={() => setActive(mastercard)}>
                <Image objectFit={"cover"} src={mastercard} />
              </Box>

              <Box {...boxStyle} onClick={() => setActive(paypal)}>
                <Image objectFit={"cover"} w={"50%"} src={paypal} />
              </Box>
            </Stack>
          </Stack>

          <Stack>
            <Heading fontSize="1.5em">Enter amount</Heading>
            <Stack>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitAmount(e.target.amount.value);
                }}
              >
                <FormControl>
                  <InputGroup size="md">
                    <Input
                      {...inputStyle}
                      style={{ borderBottom: "1px solid #1A202C" }}
                      type="text"
                      placeholder=""
                      name="amount"
                      autoComplete="off"
                    />
                    <InputRightElement width="4.5rem">
                      <Box style={{ width: "25px", height: "25px" }}>
                        <Image objectFit={"cover"} src={active} />
                      </Box>
                    </InputRightElement>
                  </InputGroup>
                  <FormErrorMessage>error message</FormErrorMessage>
                </FormControl>
                <Stack alignItems={"center"}>
                  <Button
                    mt="15px"
                    height="40px"
                    {...btnStyle}
                    color="#fff"
                    width="80%"
                    borderRadius={"25px"}
                    type="submit"
                  >
                    PROCEED
                  </Button>
                </Stack>
              </form>
            </Stack>
          </Stack>
        </Stack>
      ) : (
        <Stack>
          <Stack style={{ marginBottom: "20px" }}>
            <Heading fontSize="1.5em">Withdrawal Verification</Heading>
          </Stack>

          <Stack>
            <Heading fontSize="1.5em">Enter code sent to your email</Heading>

            <Stack>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitCode(e.target.code.value);
                }}
              >
                <FormControl>
                  <InputGroup size="md">
                    <Input
                      {...inputStyle}
                      style={{ borderBottom: "1px solid #1A202C" }}
                      type="text"
                      placeholder=""
                      name="code"
                      value={"25AKD"}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <FormErrorMessage>error message</FormErrorMessage>
                </FormControl>
                <Stack alignItems={"center"}>
                  <Button
                    mt="15px"
                    height="40px"
                    {...btnStyle}
                    color="#fff"
                    width="80%"
                    borderRadius={"25px"}
                    type="submit"
                  >
                    PROCEED
                  </Button>
                </Stack>
              </form>
            </Stack>
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default WithdrawChart;
